module.exports = __webpack_public_path__ + "static/media/bg.dde1a0bc.png";